<template>
    <div class="bg-white rounded box-shadow p-3">
        <b-modal hide-footer id="add-trainee-modal" size="lg" title="Add Trainee To Batch">
            <div v-show="show"
                 class="alert alert-danger alert-dismissible fade show"
                 role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
            </div>
            <div class="modal-content bg-white rounded box-shadow">
                <div class="form-row">
                    <div class="col-md-12 col-sm-12 col-lg-12">
                        <label class="col-form-label col-form-label-sm" for="batch_id">Select Batch<span style="color: red" v-if="batches.length === 0">[All batches are full]</span></label>
                        <select v-model="batch_id" v-validate="'required'" id="batch_id" name="batch_id" class="form-control form-control-sm" >
                            <option :value="''" selected>Select Batch</option>
                            <option v-for="(batch, index) in batches" :key="index" :value="batch.id" >
                                {{ batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                            </option>
                        </select>
                        <div class="invalid-feedback">
                            Please Select Batch
                        </div>
                    </div>
                </div>

                <div class="form-row mt-3 mb-3">
                    <div class="float-right">
                        <span v-if="userPermission.includes('trainee-to-batch-create')" ><b-button class="form-control-sm mr-2" v-if="!this.btn_edit" variant="success" @click.prevent="save" >Add</b-button></span>
                        <span v-if="userPermission.includes('trainee-to-batch-update')" ><b-button class="form-control-sm mr-2" v-if="this.btn_edit" variant="warning" @click.prevent="update(batch_trainee_id)" >Update</b-button></span>
                        <b-button class="form-control-sm" size="sm" variant="danger" @click="$bvModal.hide('add-trainee-modal')">Cancel</b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        name: "AddToTrainee",
        props: ["batches", "trainee_id", "batch_id", "btn_edit", "batch_trainee_id"],
        data() {
            return {
                validation_errors: {},
                show: false,
            };
        },
        mounted() {},
        methods: {
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/batch/trainee/store", {
                                batch_id: this.batch_id,
                                trainee_id: this.trainee_id
                            })
                            .then(response => {
                                if (!response.data.error) {
                                    if (response.data.permissionError){
                                        this.$bvToast.toast(response.data.permissionError, {
                                            title: "Error",
                                            autoHideDelay: 5000,
                                            variant: "danger"
                                        });
                                    }else{
                                        this.$bvToast.toast(response.data.message, {
                                            title: "Success",
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        });
                                        this.$bvModal.hide("add-trainee-modal");
                                        this.batch_id = "";
                                        this.$emit("search");
                                    }
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            update(batch_trainee_id) {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/batch/trainee/update/" + batch_trainee_id, {
                                batch_id: this.batch_id,
                                trainee_id: this.trainee_id
                            })
                            .then(response => {
                                if (!response.data.error) {
                                    if (response.data.permissionError){
                                        this.$bvToast.toast(response.data.permissionError, {
                                            title: "Error",
                                            autoHideDelay: 5000,
                                            variant: "danger"
                                        });
                                    }else{
                                        this.$bvToast.toast(response.data.message, {
                                            title: "Success",
                                            autoHideDelay: 5000,
                                            variant: "success"
                                        });
                                        this.$bvModal.hide("add-trainee-modal");
                                        this.batch_id = "";
                                        this.$emit("search");
                                    }
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
